document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".luxury-reviews").forEach((section) => {

    const slider = section.querySelector(".reviews-slider");
    const prev = section.querySelector(".reviews-arrow.prev");
    const next = section.querySelector(".reviews-arrow.next");

    if (!slider) return;

    const getScrollAmount = () => {
      const card = slider.querySelector(".review-card");
      if (!card) return 350;

      const gap = parseInt(window.getComputedStyle(slider).gap) || 24;
      return card.offsetWidth + gap;
    };

    /* ----------------------------
       Arrow Buttons
    -----------------------------*/

    if (next) {
      next.addEventListener("click", () => {

        slider.scrollBy({
          left: getScrollAmount(),
          behavior: "smooth"
        });

      });
    }

    if (prev) {
      prev.addEventListener("click", () => {

        slider.scrollBy({
          left: -getScrollAmount(),
          behavior: "smooth"
        });

      });
    }

    /* ----------------------------
       Auto Play
    -----------------------------*/

    let autoPlay;

    function startAutoPlay() {

      autoPlay = setInterval(() => {

        const maxScroll =
          slider.scrollWidth - slider.clientWidth;

        if (slider.scrollLeft >= maxScroll - 5) {

          slider.scrollTo({
            left: 0,
            behavior: "smooth"
          });

        } else {

          slider.scrollBy({
            left: getScrollAmount(),
            behavior: "smooth"
          });

        }

      }, 5000);

    }

    function stopAutoPlay() {

      clearInterval(autoPlay);

    }

    startAutoPlay();

    /* ----------------------------
       Pause on Hover
    -----------------------------*/

    slider.addEventListener("mouseenter", stopAutoPlay);

    slider.addEventListener("mouseleave", startAutoPlay);

    /* ----------------------------
       Touch Devices
    -----------------------------*/

    slider.addEventListener("touchstart", stopAutoPlay);

    slider.addEventListener("touchend", startAutoPlay);

  });

});